/* @flow */

import React, { useState } from "react";
import cn from "classnames";
import styles from "./styles.scss";

import HeartFilledAnimateIcon from "icons/heart_filled_animate.svg";
import HeartFilledIcon from "icons/heart_filled.svg";
import HeartEmptyIcon from "icons/heart.svg";
import { useTranslate } from "@awardit/react-use-translate";
import { Button } from "@crossroads/ui-components";

type Props = {
  className?: string,
  size?: string,
  inWishlist: boolean,
  onClick?: (value: boolean) => void | null | typeof undefined,
};

const WishlistIcon = ({ className, size, inWishlist, onClick }: Props) => {
  const [animate, setAnimate] = useState<boolean>(false);
  const t = useTranslate();

  const toggleWishlist = event => {
    if (typeof onClick === "function") {
      event.preventDefault();

      if (inWishlist) {
        setAnimate(false);
        onClick(false);
      }
      else {
        setAnimate(true);
        onClick(true);
      }
    }
  };

  return (
    <Button
      className={cn(
        styles.block,
        className,
        { [styles.small]: size === "small" }
      )}
      aria-label={inWishlist ? t("WISHLIST.REMOVE_FROM_WISHLIST") : t("WISHLIST.ADD_TO_WISHLIST")}
      onClick={toggleWishlist}
    >
      {inWishlist && animate &&
        <HeartFilledAnimateIcon aria-label={t("ICONS.HEART_EMPTY")} />
      }
      {inWishlist && !animate &&
        <HeartFilledIcon aria-label={t("ICONS.HEART_FILLED")} />
      }
      {!inWishlist &&
        <HeartEmptyIcon aria-label={t("ICONS.HEART_EMPTY")} />
      }
    </Button>
  );
};

export default WishlistIcon;
